import { LESS_1232_MEDIA_QUERY, LESS_768_MEDIA_QUERY } from '../../../consts/adaptive';
import { cssToObject } from '../../../../utils/cssToObject';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';

export const styles = {
    container : {
        width: '100%',
        padding: [40, 0, 0],

        '& *': {
            boxSizing: 'border-box',
        }
    },
    wrapper : {
        display: 'grid',
        columnGap: '16px',
        rowGap: '24px',
        gridTemplateColumns: 'repeat(3, 1fr)',
        padding: [32, 0],
    },
    header : {
        ...cssToObject(defaultTheme.theme.mixin.fontTitleS),
        margin: 0,
    },
    button : {
        display: 'flex',
        justifyContent: 'center',
    },
    buttonShowMore: {
        '& > span': {
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
        }
    },
    buttonIcon: {
        display: 'block',
        marginLeft: 4,
        transition: 'all 300ms ease-in-out',
        padding: [0, 0, 2],

        '& svg': {
            width: 8,
            height: 5,
        },

        '& svg path': {
            fill: defaultTheme.theme.colorVariables.iconPrimary,
        }
    },
    buttonIconUp: {
        transform: 'rotate(-180deg)',
    },
    [LESS_1232_MEDIA_QUERY]: {
        wrapper: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
    },
    [LESS_768_MEDIA_QUERY]: {
        wrapper: {
            gridTemplateColumns: '1fr',
        },
        button : {
            marginBottom: 40,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
